<template>
<!-- Alternative: https://github.com/apertureless/vue-parallax mit preload image thumbs -->
    <div>
        <slot name="header"></slot>
        <v-parallax v-if="parallax && isLgAndUpDevice"  :lazy-src="thumb" :src="img" :height="height"  :class="{ bottomUp: bottom}">
            <v-overlay :value="true" absolute :color="gradientColor" :opacity="darken" :style="rowStyle">
                <v-row
                    align="center"
                    justify="center"
                >
                    <v-col class="text-center hlParallaxText" cols="12" sm="10" :md="(isCaption)?8:5">
                        <h3 class="mb-4" :class="(isCaption)?fontTitle:fontHeading" :style="titleStyle">{{title}}</h3>
                        <h4 class="subtitleText px-8 mt-8 font-weight-medium" v-html="subtitle"></h4>
                        <slot></slot>
                        <p style="padding-bottom:5em"></p><!-- Bootom up leerzeile -->
                    </v-col>
                </v-row>
            </v-overlay>
        </v-parallax>
        <v-img v-else :src="img" style="z-index:2" :eager="eager" :lazy-src="thumb" :class="{'pt-8':isCaption}" width="100%" :height="(isLgAndUpDevice)?height:fullHeightPx" :min-height="(fullHeightOnXs && isXsDevice)?(bgHeight):(0.9*height)" :gradient="gradientOpacity" :position="bgPos">
            <v-row
                align="center"
                justify="center"
                class="fill-height"
                :style="rowStyle"
            >
                <v-col class="text-center hlParallaxText" cols="12" >
                    <h3 class="mb-4 pa-1 py-4 grey--text text--darken-4" :style="titleStyle" v-html="title">{{title}}</h3> <!-- :class="(isCaption)?(fontTitle+' mt-12'):fontHeading" -->
                    <h4 :class="(isXsDevice)?'subtitleTextOnXs':'subtitleText'" :style="subTitleStyle" v-html="subtitle"></h4>
                    <slot></slot>
                    <p style="padding-bottom:5em"></p><!-- Bootom up leerzeile -->
                </v-col>
            </v-row>
        </v-img>
        <router-link v-if="isLgAndUpDevice" to="/" class="no-underline"><img src="/img/logos/Logo_Katrin.png" height="200px" style="position:fixed;left:10px;top:100px;z-index:1"/></router-link>
    </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
export default {
    mixins: [layoutMixin],
    props:{
        img:{
            type:String
        },
        thumb:{
            type:String,
            default:undefined
        },
        title:{
            type:String
        },
        subtitle:{
            type:String
        },
        height:{
        },
        borderColor:{
            type:String
        },
        darken:{
            type:Number,
            default:0.1
        },
        lighten:{
            type:Number,
            default:0
        },
        bottom:{
            type:Boolean,
            default:true
        },
        fullHeightOnXs:{
            type:Boolean,
            default:false
        },
        isCaption:{
            type:Boolean,
            default:false
        },
        titleBgColor:{
            type:String,
            default:null
        },
        parallax:{
            type:Boolean,
            default:false
        },
        eager:{
            type:Boolean,
            default:false
        },
        fontSize:{
            type: String,
            default: "6em"
        },
        bgPos:{
            type:String,
            default:"center center"
        },
        hasLogo:{
            type:Boolean,
            default:true
        }
        
    },
    computed:{
        rowStyle(){
            let res= this.getRowStyle(this.borderColor);
            res.color="rgba(0,0,0)";
            return res;
        },
        gradientOpacity(){
            if(this.lighten){
                return this.getGradientLightOpacity(this.lighten);
            }
            return this.getGradientOpacity(this.darken);
        },
        gradientColor(){
            return `#000`;
        },
        fullHeightPx(){
            return (this.fullHeightOnXs && this.isXsDevice)?this.bgHeight*0.9:'auto';
        },
        titleStyle(){
            return {
                'font-size':this.fontSize,
                'font-weight':700,
                'border':`1px solid ${this.borderColor}`,
                'letter-spacing':'0.06em',
                'line-height':this.isMdAndUpDevice?'100px':'1.5em'
            }
        },
        subTitleStyle(){
            return {
                'font-size':this.fontSize,
                'font-weight':700,
                'line-height':this.isMdAndUpDevice?'1.2em':'1.5em'
            }
        },
        
    }
}
</script>
<style scoped>
.subtitleText{
    font-size:1.3rem;
    font-weight:400;
}
.subtitleTextOnXs{
    font-size:1.1rem;
    font-weight:500;
}
</style>
<style>

.v-parallax__content{
    padding-left: 0!important;
    padding-right: 0!important;
}
</style>